import React from "react";
import { DeviceStatus } from "@app/shared/src/models";
import { Tag } from "@app/shared/src/components_v2";

/**
 * A device's health at a glance. Directors triage by colour; the label carries the detail.
 * "Stale" is called out separately from the stored status because a unit that hasn't checked in
 * is a different problem — and a different phone call — from one reporting a fault.
 */
export const DeviceStatusTag: React.FC<{ status?: DeviceStatus; lastHeartbeat?: Date | string }> = ({
    status,
    lastHeartbeat,
}) => {
    const heartbeat = lastHeartbeat ? new Date(lastHeartbeat) : undefined;
    const staleMs = heartbeat && !Number.isNaN(heartbeat.getTime()) ? Date.now() - heartbeat.getTime() : undefined;
    const isStale = staleMs !== undefined && staleMs > 15 * 60 * 1000;

    if (isStale) {
        const days = Math.floor((staleMs ?? 0) / 86_400_000);
        return <Tag tone="crit">{days >= 1 ? `Offline ${days}d` : "Offline"}</Tag>;
    }
    if (status === DeviceStatus.Healthy) return <Tag tone="safe">Healthy</Tag>;
    // Named rather than folded into "Needs attention": a unit restarting to apply settings is
    // doing what it was told, and a director reading a fault label would go chasing one.
    if (status === DeviceStatus.Reconfiguring) return <Tag tone="warn">Reconfiguring</Tag>;
    if (status === undefined || status === DeviceStatus.Unknown) return <Tag tone="mute">Unknown</Tag>;
    return <Tag tone="warn">Needs attention</Tag>;
};
